import { render, staticRenderFns } from "./ActivityConfirmationVideo.vue?vue&type=template&id=106c977e&scoped=true"
import script from "./ActivityConfirmationVideo.vue?vue&type=script&lang=ts"
export * from "./ActivityConfirmationVideo.vue?vue&type=script&lang=ts"
import style0 from "./ActivityConfirmationVideo.vue?vue&type=style&index=0&id=106c977e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106c977e",
  null
  
)

export default component.exports